import { Component, inject, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

import { PvdsComponent } from "../pvds/pvds.component";
import { DaysComponent } from "../days/days.component";
import { AccordionsService } from "@features/home/services/accordions.service";
import { DaysData } from "@shared/models";
import { Observable } from "rxjs";

@Component({
  selector: "app-accordions",
  standalone: true,
  imports: [PvdsComponent, DaysComponent, CommonModule],
  templateUrl: "./accordions.component.html",
  styleUrl: "./accordions.component.scss",
})
export class AccordionsComponent {
  accordionsService = inject(AccordionsService);

  @Input() getData: boolean = false;

  loadingData: DaysData = {} as DaysData;

  daysData$: Observable<DaysData> = this.accordionsService.getDaysData();
}
